import dateService from '@gem/services/date-service';

import Tasks from 'APP/Tasks';
import { searchModel } from 'APP/model/model';
import Entities from 'STORE';

const getFormatDate = (date) => {
  let options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  if (dateService.isLastYear(date)) {
    options = {
      month: 'short',
      day: 'numeric',
    };
  }
  if (dateService.isLastWeek(date)) {
    options = {
      weekday: 'short',
    };
  }
  if (dateService.isToday(date)) {
    options = {
      hour: 'numeric',
      minute: 'numeric',
    };
  }
  return dateService.format(date, options);
};

const getSenderData = (group, message) => {
  if (group.isChannel) {
    return {
      avatarUrl: group.avatarUrl,
      avatarTitle: group.avatarTitle,
      avatarColorIndex: group.avatarColorIndex,
      verified: group.verified,
    };
  }
  let sender = Entities.usersStore.getUserById(message.senderId.toString());

  if (group.isSavedMessages && message.forwardedMessage) {
    // if redirected from channel
    const forwardGroup = Entities.GroupsStore.getGroupById(message.forwardedMessage.groupId);
    if (forwardGroup && forwardGroup.isChannel) {
      sender = forwardGroup;
    } else {
      sender = Entities.usersStore.getUserById(message.forwardedMessage.senderId.toString());
    }
  }
  if (sender) {
    return {
      avatarUrl: sender.avatarUrl,
      avatarTitle: sender.avatarTitle,
      avatarColorIndex: sender.avatarColorIndex,
      verified: sender.verified,
      usernameBadge: sender.usernameBadge,
    };
  }
};

const buildTextChunkFromContent = (content, highlights) => {
  const plainText = content ? content.replace(/<\/?em>/g, '') : '';
  const selections = Array.isArray(highlights) ? highlights : [];

  if (selections.length === 0) {
    return {
      plainText,
      textChunk: {
        before: plainText,
        select: '',
        after: null,
      },
    };
  }

  let currentIndex = 0;

  const buildChunk = (selectionIndex) => {
    if (selectionIndex >= selections.length) {
      return {
        before: plainText.slice(currentIndex),
        select: '',
        after: null,
      };
    }

    const { start, end } = selections[selectionIndex];

    const before = plainText.slice(currentIndex, start);
    const select = plainText.slice(start, end);

    currentIndex = end;

    const after = buildChunk(selectionIndex + 1);

    return {
      before,
      select,
      after,
    };
  };

  return {
    plainText,
    textChunk: buildChunk(0),
  };
};

const getMessage = (group, result) => {
  const { content, highlights, message } = result;

  const { plainText, textChunk } = buildTextChunkFromContent(content, highlights);

  return {
    id: message.id,
    textChunk,
    payloadType: message.payload.payloadType,
    text: plainText,
    date: getFormatDate(+message.serverTime),
    ...getSenderData(group, message),
  };
};

export default async ({ value, cursor, groupId }) => {
  try {
    const { results, cursor: nextCursor } = await searchModel.searchMessages({
      groupId,
      cursor,
      limit: 100,
      query: value,
    });

    if (results.length > 0) {
      await Tasks.relationships.loadUnknownDataFromMessages({
        messages: results.map(({ message }) => message),
      });
    }

    const group = Entities.GroupsStore.getGroupById(groupId.toString());
    const mapMessage = getMessage.bind(null, group);

    return {
      results: results.map(mapMessage),
      cursor: nextCursor,
      error: null,
    };
  } catch (error) {
    return { error };
  }
};
